import React, {useState, useEffect} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {COLOR_GRAY_BANNER_BACKGROUND} from "../constants/general-constants";


export default function FloorRowIcon({id, icon, clickFunction}){
	
	
	const [thisBackground, setThisBackground] = useState(COLOR_GRAY_BANNER_BACKGROUND);
	
	useEffect(() => {
		
	}, [id]);
	
	const handleMouseOver = () => {
		setThisBackground("orange");
	};
	
	const handleMouseLeave = () => {
		setThisBackground(COLOR_GRAY_BANNER_BACKGROUND);		
	};
	
	const iconCircle = {
		display:"flex",
		width:"30px",
		height:"30px",
		alignItems:"center",
		justifyContent:"space-around",
		borderRadius:"15px",
		backgroundColor:thisBackground,
		marginLeft:"10px"
	};
	
	const iconStyle = {
		display:"flex",
		color:"white",
		width:"15px",
		height:"15px"
	};
	
	return (
		<div style={iconCircle} onMouseOver={handleMouseOver} onMouseLeave={handleMouseLeave}>
			<FontAwesomeIcon icon={icon} style={iconStyle} onClick={clickFunction}/>
		</div>
	);
}